/* Brand tiles (/pages/brands, homepage brand grid) link to /search?q=vendor:"X". A brand with no
   active products lands on an empty grid (found 2026-10-21: MaxLoad, RedStar Exhaust, Triton
   Motorsports). Each tile is checked once (verdict cached 30 min in sessionStorage) and hidden when
   its target has no products. A failed check keeps the tile. */
(function () {
  var tiles = [].slice.call(document.querySelectorAll('a.es-brand-tile[href^="/search"]'));
  if (!tiles.length) return;
  var TTL = 30 * 60 * 1000;
  function check(a) {
    var h = a.getAttribute('href'), key = 'es-bt:' + h;
    try { var v = JSON.parse(sessionStorage.getItem(key) || 'null'); if (v && Date.now() - v.t < TTL) return Promise.resolve(v.ok); } catch (_) {}
    return fetch(h, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) return false;
      return r.text().then(function (t) {
        var ok = new DOMParser().parseFromString(t, 'text/html').querySelector('#es-grid .product-item') !== null;
        try { sessionStorage.setItem(key, JSON.stringify({ ok: ok, t: Date.now() })); } catch (_) {}
        return ok;
      });
    }).catch(function () { return true; });
  }
  var i = 0;
  function next() {
    if (i >= tiles.length) return;
    var a = tiles[i++];
    check(a).then(function (ok) { if (!ok) a.style.display = 'none'; next(); });
  }
  next(); next();
})();
